import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { fallback, level } = this.props;
      if (fallback) return fallback;

      if (level === 'route') {
        return (
          <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center">
            <div className="w-14 h-14 rounded-full bg-red-500/10 flex items-center justify-center mb-4">
              <svg className="w-7 h-7 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
            </div>
            <h2 className="font-['Outfit'] font-bold text-lg text-gray-800 mb-2">Something went wrong</h2>
            <p className="font-['Manrope'] text-gray-500 text-sm mb-6 max-w-md">This section encountered an error. The rest of the app should still work.</p>
            <button onClick={() => { this.setState({ hasError: false, error: null }); }} className="px-6 py-2.5 rounded-full bg-[#D4A843] text-[#0B1D3A] font-['Manrope'] font-semibold text-sm hover:bg-[#F5D78E] transition-colors">
              Try Again
            </button>
          </div>
        );
      }

      // Global level — full screen
      return (
        <div className="min-h-screen bg-[#050B14] flex items-center justify-center p-8">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-5">
              <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
            </div>
            <h1 className="font-['Outfit'] font-bold text-xl text-white mb-3">Something went wrong</h1>
            <p className="font-['Manrope'] text-white/40 text-sm mb-6">We're sorry — please refresh the page to continue.</p>
            <button onClick={() => window.location.reload()} className="px-8 py-3 rounded-full bg-[#D4A843] text-[#0B1D3A] font-['Manrope'] font-bold text-sm hover:bg-[#F5D78E] transition-colors">
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
